import { useCallback, useEffect, useState } from 'react';

const useDebounce = (
  countdownInMilliseconds: number,
  action: (...args: any[]) => void,
): {
  execute: (...params: any[]) => void;
} => {
  const [internalTimeout, setInternalTimeout] = useState<NodeJS.Timeout>();
  const [internalCountdown, setInternalCountdown] = useState<number>(0);

  useEffect(() => {
    setInternalCountdown(countdownInMilliseconds);
  }, [countdownInMilliseconds, setInternalCountdown]);

  const execute = useCallback(
    (...params: any[]) => {
      if (internalTimeout) {
        clearTimeout(internalTimeout);
      }

      setInternalTimeout(
        setTimeout(() => {
          action(...params);
        }, internalCountdown),
      );
    },
    [internalCountdown, action, internalTimeout, setInternalTimeout],
  );

  return {
    execute,
  };
};

export default useDebounce;
